module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"teamWorkingMessage":"Estamos trabajando:","teamReleasesMessage":"Nuevos incrementos:"},"br":{"teamWorkingMessage":"Estamos trabalhando:","teamReleasesMessage":"Novos desenvolvimentos:"},"pe":{"teamWorkingMessage":"Estamos trabajando:","teamReleasesMessage":"Nuevos incrementos:"}}')
  delete Component.options._Ctor
}
